import { API_URL } from '../../shared/actions'
import { customReducer } from './customReducer'

export default function moduleAdminReducer(state, action) {
  const {
    MODULEADMIN: { GET_ALL_MODULEADMINS, ADD_MODULEADMIN, EDIT_MODULEADMIN, DELETE_MODULEADMIN },
  } = API_URL

  return customReducer(state, action, 'moduleAdmins', [GET_ALL_MODULEADMINS, ADD_MODULEADMIN, EDIT_MODULEADMIN, DELETE_MODULEADMIN])
}
